import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AaradhyaLogo from '../assets/Aaradhya-logo.png';

const Header = ({ isLoggedIn, isAdmin, handleLogout }) => {
    return (
        <Navbar bg="light" expand="lg" className="shadow-sm sticky-top">
            <Container>
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                    <img
                        src={AaradhyaLogo}
                        height="50"
                        className="d-inline-block me-2"
                        alt="Aaradhya Library Logo"
                    />
                    <span className="fw-bold fs-5 text-primary">Aaradhya Library</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="/">Home</Nav.Link>
                        <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
                        
                        {isLoggedIn ? (
                            <>
                                {isAdmin ? (
                                    <Nav.Link as={Link} to="/admin/dashboard">Admin Dashboard</Nav.Link>
                                ) : (
                                    <Nav.Link as={Link} to="/dashboard">My Dashboard</Nav.Link>
                                )}
                                <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                            </>
                        ) : (
                            <>
                                <Nav.Link as={Link} to="/login">Login</Nav.Link>
                                <Nav.Link as={Link} to="/register">Register</Nav.Link>
                            </>
                        )}
                        
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;